import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontFamily: 'Poppins, sans-serif',
    position: 'relative',
    backgroundColor: 'white',
  },
  headerContainer: {
    position: 'absolute',
    left: '5%',
    width: '90%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  title: {
    color: '#666C6F',
    fontSize: '13px',
    fontWeight: 600,
  },
  legendContainer: {
    width: '150px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end',
    fontSize: '13px',
    fontWeight: 600,
  },
  chartContainer: {
    width: '330px',
    height: '330px',
    marginTop: '70px',
    '@media(max-width: 900px)': {
      width: '100%',
      height: '200px',
      marginTop: '40px',
    },
  },
  femaleText: {
    background: '#FF3301',
    textTransform: 'capitalize',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  maleText: {
    marginLeft: '24px',
    background: '#2F6BF4',
    textTransform: 'capitalize',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    '@media(max-width: 900px)': {
      marginLeft: '10px',
    }
  },
  footerContainer: {
    width: '80%',
    height: '120px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '@media(max-width: 900px)': {
      height: '60px',
    }
  },
  footerTextContainer: {
    textAlign: 'center',
  },
  footerText: {
    color: '#B2B9C0',
    fontSize: '12px',
    fontWeight: 600,
    textTransform: 'uppercase',
    margin: '0 auto',
  },
  footerPercent: {
    color: '#666C6F',
    fontSize: '40px',
    margin: '0 auto',
    '@media(max-width: 900px)': {
      fontSize: '20px',
    },
  },
});
